import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Custom Drag Preview component
 */
export const customDragPreviewStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  root: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "4px",
    boxShadow: `0 12px 24px -6px rgba(0, 0, 0, .25), 0 0 0 1px rgba(0, 0, 0, .08)`,
    color: theme.palette.primary.contrastText,
    display: "inline-grid",
    fontSize: "14px",
    gap: "8px",
    gridTemplateColumns: "auto auto",
    padding: "4px 8px",
    pointerEvents: "none",
  },
  icon: {
    alignItems: "center",
    display: "flex",
  },
  label: {
    alignItems: "center",
    display: "flex",
  },
});

/**
 * Styles for Multiple Drag Preview component
 */
export const multipleDragPreviewStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  root: {
    alignItems: "flex-start",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "4px",
    boxShadow: `0 12px 24px -6px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.08)`,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "8px",
  },
  item: {
    alignItems: "center",
    color: theme.palette.primary.contrastText,
    display: "inline-grid",
    fontSize: "14px",
    gap: "8px",
    gridTemplateColumns: "auto auto",
  },
  icon: {
    alignItems: "center",
    display: "flex",
  },
  label: {
    alignItems: "center",
    display: "flex",
  },
  badge: {
    border: `solid 2px ${theme.palette.common.white}`,
  },
});
